import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-slate-800 font-bold">
                EV
              </div>
              <div>
                <div className="font-semibold">Eastbourne Vehicle</div>
                <div className="font-semibold">Air Conditioning</div>
              </div>
            </div>
            <p className="text-slate-400 text-sm">
              Professional vehicle air conditioning service and repair in Eastbourne and East Sussex.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/regas" className="hover:text-white transition-colors">
                  Air-Con Regas
                </Link>
              </li>
              <li>
                <Link to="/diagnostics" className="hover:text-white transition-colors">
                  Diagnostics & Leak Testing
                </Link>
              </li>
              <li>
                <Link to="/problems" className="hover:text-white transition-colors">
                  Common Problems
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Unit 2, Hawthorn Road, Eastbourne BN23 6QA</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href="tel:01323643333" className="hover:text-white transition-colors">
                  01323 643333
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Clock className="w-4 h-4 flex-shrink-0" />
                <span>Mon-Fri 8am-5pm</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm text-slate-400">
          <p>&copy; {new Date().getFullYear()} Eastbourne Vehicle Air Conditioning. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
